/*
 * Convenience utility for declaring media queries in styled-components
 * Ex: ` ${media.tablet` font-size: 10px `} `
 * recipe: https://www.styled-components.com/docs/advanced#media-templates
 */

import { css } from 'styled-components';


const sizes = {
    huge: 2560,
    big: 2200,
    large: 1440,
    desktop: 1024,
    tablet: 768,
    phone: 576,
};

// Iterate through the sizes and create a media template
export default Object.keys(sizes).reduce((acc, label) => {
    acc[label] = (...args) => css`
        @media (max-width: ${sizes[label] / 16}em) {
            ${css(...args)}
        }
    `;
    return acc;
}, {});
